import "@css-utils:utils.css";
import "@css-utils:reset.css";
import "@css-utils:font.css";
import "katex/dist/katex.min.css";
// Initialise i18next before the app renders
import "@libs:i18n";

import { AppProvider } from "@app-setup:provider";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const env = import.meta.env.VITE_ENVIRONMENT || "local";

if (env != undefined && env != "local") {
  console.log(`Linking sentry to environment ${env}....`);
  Sentry.init({
    dsn: "https://5c76e56de095d2dc150777ae8d73fac4@o1432167.ingest.us.sentry.io/4507130441564160",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: env,
  });
}

createRoot(document.getElementById("root")!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <AppProvider />
  </StrictMode>,
);
